import React from "react";
import { Menu, Dropdown } from "antd";
import { connect } from "react-redux";
import {
  EditOutlined,
  SettingOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import Icon from "components/util-components/Icon";
import { logout } from "redux/auth.slice";

const menuItem = [
  {
    title: "Profil",
    icon: EditOutlined,
    path: "/app/user-profile",
  },
];

export const NavProfile = ({ logout, userName, name, role }) => {
  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex">
          <div className="pl-3">
            <h4 className="mb-0">{name}</h4>
            <span className="text-muted">{role}</span>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {menuItem.map((el, i) => {
            return (
              <Menu.Item key={i}>
                <a href={el.path}>
                  <Icon className="mr-3" type={el.icon} />
                  <span className="font-weight-normal">{el.title}</span>
                </a>
              </Menu.Item>
            );
          })}
          <Menu.Item key={menuItem.legth + 1} onClick={(e) => logout()}>
            <span>
              <LogoutOutlined className="mr-3" />
              <span className="font-weight-normal">Chiqish</span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
      <Menu className="d-flex align-item-center" mode="horizontal">
        <Menu.Item>
          <span><SettingOutlined /> </span>
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
};

const mapStateToProps = ({ auth }) => ({
  userName: auth.userName,
  role: auth.role,
  name: auth.name
});

export default connect(mapStateToProps, { logout })(NavProfile);
